import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center pb-4" }
const _hoisted_2 = { class: "text-xl flex-1" }

import { withDefaults } from 'vue'

interface Emits {
  (e: 'close'):void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    showIcon: { default: true }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'close'):void
}), expose: any, slots: any, attrs: any }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (__props.showIcon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "el-icon-close cursor-pointer text-2xl opacity-65",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emits('close')), ["self"]))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})